(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabObjectsRedeploymentController', TabObjectsRedeploymentController);

    TabObjectsRedeploymentController.$inject = ['$uibModalInstance', '$interval', 'entityId', 'TabObjectsRedeploy', 'TabObjectsRedeployablesCounter'];

    function TabObjectsRedeploymentController($uibModalInstance, $interval, entityId, TabObjectsRedeploy, TabObjectsRedeployablesCounter) {

        var vm = this;
        vm.entityId = entityId;
        vm.formData = {
            'operations': {'restore': false, 'restart': true}
        };
        vm.redeployObjCounter = TabObjectsRedeployablesCounter;

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        // *********************************** //
        // ** Single TabObject confirmation ** //
        // *********************************** //
        vm.confirmRedeployment = function (id) {
            TabObjectsRedeploy.redeploy({'id': id}, {}, onSuccess, onError);

            function onSuccess(data) {
                $uibModalInstance.close(true);
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

        // ************************************ //
        // *** Mass TabObjects confirmation *** //
        // ************************************ //
        vm.confirmRedeploymentAll = function () {
            TabObjectsRedeploy.redeployAll({
                'restore': vm.formData.operations.restore,
                'restart': vm.formData.operations.restart
            }, {}, onSuccess, onError);

            function onSuccess(data) {
                $uibModalInstance.close(true);
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        };
    }
})();
